var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-container"},[_c('ToggleSidebar',{attrs:{"collapse":_vm.isCollapse},on:{"toggleMenu":_vm.handleChangeCollapse}}),_c('BreadCrumb'),_c('RightMenu',{staticClass:"right-menu"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }